var genSelector = function genSelector(path) {
  var selector = [];
  var win = window;
  var doc = document;

  for (var i = 0, j = path.length; i < j; i++) {
    var el = path[i];

    if (el === win || el === doc) {
      break;
    }

    if (el.id) {
      selector.push("#".concat(el.id));
      break;
    } else if (el.className && typeof el.className === 'string') {
      selector.push('.' + el.className.split(/\s+/).filter(function (item) {
        return !!item;
      }).join('.'));
    } else {
      selector.push(el.nodeName);
    }
  }

  return selector.reverse().join(' ');
};

export default function (pathOrTargetEl) {
  if (Object.prototype.toString.apply(pathOrTargetEl) === '[object Array]') {
    return genSelector(pathOrTargetEl);
  } else {
    var path = [];
    var el = pathOrTargetEl;

    while (el) {
      path.push(el);
      el = el.parentNode;
    }

    return genSelector(path);
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ali_aes-tracker-plugin-longtask@1.0.1@@ali/aes-tracker-plugin-longtask/es/utils/genXpath.js
// module id = null
// module chunks = 